// Fit Check page - dedicated JD analyzer page

import { FitAssessment } from '../components/sections/FitAssessment';

export function FitCheck() {
  return (
    <main className="pt-16">
      <FitAssessment />
    </main>
  );
}
